import LimitOrder from '~/components/LimitOrder'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/limit-order`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_limit_order_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_limit_order_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}

export default LimitOrder
